import script from "./VariantComponents.vue?vue&type=script&setup=true&lang=ts"
export * from "./VariantComponents.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__